import { useQuery } from "@tanstack/react-query";

import { useRestClient } from "@/lib/restClient";

export interface GrantableAccount {
  account_id: string;
  email: string;
  profile: string;
  /** Effective scopes, e.g. `tenant:42` for a client account. */
  scopes?: string[];
}

/**
 * Accounts a dashboard can be published to one by one, such as a client's service
 * account. Listing accounts is an administrator capability: for anyone else the
 * query is disabled or fails, and no account choice is offered.
 */
export function useGrantableAccounts(
  enabled: boolean,
  kind: "dashboard" | "template" = "dashboard",
) {
  const apiFetch = useRestClient();
  return useQuery({
    queryKey: kind === "template" ? ["dashboard-template-recipients"] : ["accounts", "profiles"],
    queryFn: () =>
      apiFetch<GrantableAccount[]>(
        kind === "template" ? "/api/dashboard-template-recipients" : "/api/accounts",
      ),
    enabled,
    retry: false,
    staleTime: 60_000,
  });
}
